module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0019.jpg?v=c5e38b39";